import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Link,
    List,
    ListItem,
    Paper,
    Stack,
    Typography
} from "@mui/material";
import {useMainContext} from "../constants";
import {ExpandMore} from "@mui/icons-material";

export default function GirlsVarsity() {

    const { mainVariant, smallVariant, smallerVariant, smallestVariant } = useMainContext();

    return (
        <Box sx={{ maxWidth: 'lg',
            paddingLeft: { xs: "10px", sm: "20px", md: "30px"},
            paddingRight: { xs: "10px", sm: "20px", md: "30px"},
            paddingBottom: { xs: "10px", sm: "20px", md: "30px"},
            marginLeft: "auto", marginRight: "auto" }}>
            <Stack direction="column" spacing={2} sx={{ marginTop: { xs: "10px", sm: "15px", md: "20px"}}}>
                <Typography variant={ smallerVariant } sx={{ fontWeight: "bold"}}>Girls Varsity</Typography>
                <Typography variant="body1">
                    The Girls Varsity program offers competitive soccer for homeschooled young women aged 14–18.
                    All players train together as one program starting in August, with placement on our
                    Tournament or League squads determined during the first two weeks of evaluations.
                </Typography>

                <List>
                    <ListItem>
                        <Typography variant="body1">
                            <strong>Eligibility:</strong> Ages 14–18 (Advanced 12–13 year olds evaluated on a case-by-case basis).
                        </Typography>
                    </ListItem>
                    <ListItem>
                        <Typography variant="body1">
                            <strong>Team Placement:</strong> Players are placed on Tournament or League teams based on skill and registration numbers.
                        </Typography>
                    </ListItem>
                    <ListItem>
                        <Typography variant="body1">
                            <strong>Unified Training:</strong> All Varsity players receive the same high-level coaching and technical standards throughout the season.
                        </Typography>
                    </ListItem>
                </List>
                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMore/>} data-testid="soccerGirlsVarsityTournamentTeam">
                        <Typography variant={smallestVariant}>Tournament Team</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography variant="body1">
                            The Tournament Team is the elite tier of our Girls Varsity program. Equivalent to a Class B High School team, we provide a competitive environment designed for athletes looking for maximum development,  placing among the top 15 homeschooled programs in the nation. There is an additional tournament fee for this team, typically around $150.
                        </Typography>
                        <Typography variant="body1" sx={{ marginTop: "10px"}}>The Tournament Team season consists of (in addition to the General Schedule):</Typography>
                        <ul>
                            <li>Roughly 10 league games from early September to end of October</li>
                            <li>Midwestern Tournament (Fort Wayne, Indiana) early September</li>
                            <li>Playoffs and WNYCAA Tournament end of October</li>
                            <li>National Tournament end of October</li>
                            <li>1-2 CoEd Games (with Boys Tournament Team)</li>
                        </ul>
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMore/>} data-testid="soccerGirlsVarsityLeagueTeam">
                        <Typography variant={smallestVariant}>League Team</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography variant="body1">
                            Our League team plays in the local <Link className="light" href="https://wnycaa.org">WNYCAA</Link> League.
                            This team is a competitive team roughly equivalent to a class D High School team.
                        </Typography>
                        <Typography variant="body1" sx={{ marginTop: "10px"}}>The League Team season consists of (in addition to the General Schedule):</Typography>
                        <ul>
                            <li>Roughly 10 league games from early September to end of October</li>
                            <li>Binghamton Tournament mid September</li>
                            <li>Playoffs and WNYCAA Tournament end of October</li>
                        </ul>
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMore/>} data-testid="soccerGirlsVarsityPastResults">
                        <Typography variant={smallestVariant}>Past Results</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography variant="body1">2025</Typography>
                        <Typography variant="body1">
                            <ul>
                                <li>1st Place WNYCAA League and Tournament</li>
                                <li>4th Place National HomeSchool Tournament</li>
                                <li>Not in Binghamton Tournament</li>
                            </ul>
                        </Typography>
                        <Typography variant="body1">2024</Typography>
                        <Typography variant="body1">
                            <ul>
                                <li>11th Place National HomeSchool Tournament</li>
                                <li>Not in Binghamton or WNYCAA Tournament</li>
                            </ul>
                        </Typography>
                        <Typography variant="body1">2023</Typography>
                        <Typography variant="body1">
                            <ul>
                                <li>1st Place WNYCAA League and Tournament</li>
                                <li>1st Place Binghamton Tournament</li>
                                <li>7th Place National HomeSchool Tournament</li>
                            </ul>
                        </Typography>
                        <Typography variant="body1">2022</Typography>
                        <Typography variant="body1">
                            <ul>
                                <li>1st Place WNYCAA League and Tournament</li>
                                <li>1st Place Binghamton Tournament</li>
                                <li>11th Place National HomeSchool Tournament</li>
                            </ul>
                        </Typography>
                        <Typography variant="body1">2021</Typography>
                        <Typography variant="body1">
                            <ul>
                                <li>1st Place WNYCAA League</li>
                                <li>1st Place Binghamton Tournament</li>
                                <li>12th Place National HomeSchool Tournament</li>
                            </ul>
                        </Typography>
                        <Typography variant="body1">2020</Typography>
                        <Typography variant="body1">
                            <ul>
                                <li>1st Place WNYCAA League and Tournament</li>
                            </ul>
                        </Typography>
                        <Typography variant="body1">2019</Typography>
                        <Typography variant="body1">
                            <ul>
                                <li>1st Place WNYCAA League and Tournament</li>
                                <li>1st Place Binghamton Tournament</li>
                                <li>4th-8th Place HomeSchool Tournament (2nd day cancelled)</li>
                            </ul>
                        </Typography>
                        <Typography variant="body1">2018</Typography>
                        <Typography variant="body1">
                            <ul>
                                <li>1st Place WNYCAA League and Tournament</li>
                                <li>1st Place Binghamton Tournament</li>
                                <li>2nd Place National HomeSchool Tournament</li>
                            </ul>
                        </Typography>
                        <Typography variant="body1">2017</Typography>
                        <Typography variant="body1">
                            <ul>
                                <li>1st Place WNYCAA League and Tournament</li>
                                <li>1st Place Binghamton Tournament</li>
                                <li>9th Place National HomeSchool Tournament</li>
                            </ul>
                        </Typography>
                        <Typography variant="body1">2016</Typography>
                        <Typography variant="body1">
                            <ul>
                                <li>1st Place WNYCAA League</li>
                                <li>1st Place Binghamton Tournament</li>
                            </ul>
                        </Typography>
                        <Typography variant="subtitle1">2015</Typography>
                        <Typography variant="body1">
                            <ul>
                                <li>1st Place Binghamton Tournament</li>
                            </ul>
                        </Typography>

                    </AccordionDetails>
                </Accordion>
            </Stack>
        </Box>
    )
}
